import { put } from "../../../common/api/apiShared";
import { ITransferResponsibilityDialog } from "./TransferResponsibilityDialog";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../../localization/useTranslation";
import { useDotLegalQueryClient, useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";

function useTransferResponsibilityDialogHooks(props: ITransferResponsibilityDialog) {
    const snackbar = useDotLegalSnackbar();
    const { translateString } = useTranslation();
    const queryClient = useDotLegalQueryClient();

    function update() {
        return put<string>(`/ProcessingActivity/${props.processingActivityId}/transferReponsibility/`, {
            fromUser: props.fromUser.id,
            toUser: props.toUser.id,
        });
    }
    const editMutation = useDotLegalMutation(update);

    const transferResponsibility = () => {
        editMutation.mutateAsync(undefined, {
            onSuccess: (data: any) => {
                const processingActivity = data.value();
                queryClient.setQueryData("processingActivity" + props.processingActivityId, processingActivity);
                props.onCloseDialog();
                snackbar.show(translateString("responsibilityTransfered"));
            },
        });
    };

    return {
        transferResponsibility,
        isSaving: editMutation.isLoading,
    };
}

export default useTransferResponsibilityDialogHooks;
